module.exports = __webpack_public_path__ + "static/media/hiw_2.a0cafab1.svg";